module.exports = __webpack_public_path__ + "static/media/ed.35b87461.jpg";